'use client'

import { usePageVisibility } from '@/hooks/usePageVisibility'

export function PageVisibilityProvider() {
  usePageVisibility()
  return null // Ten komponent nie renderuje nic, tylko obsługuje logikę
}
